export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const SIGN_IN = "SIGN_IN";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const MFA_AUTHENTICATION = "MFA_AUTHENTICATION";
export const MFA_SUCCESS = "MFA_SUCCESS";
export const REQUEST_FAILED = "REQUEST_FAILED";
export const CLEAR_MFA_ERROR = "CLEAR_MFA_ERROR";
export const SIGN_IN_MFA = "SIGN_IN_MFA";
export const TRANSACTION_TYPE = "TRANSACTION_TYPE";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const RESEND_OTP_CHANGE_PASSWORD = "RESEND_OTP_CHANGE_PASSWORD";
export const RESEND_CODE_MFA = "RESEND_CODE_MFA";
export const RESEND_MFA_CODE_SUCCESS = "RESEND_MFA_CODE_SUCCESS";
export const CLEAR_SUCCESS_MESSAGE = "CLEAR_SUCCESS_MESSAGE";
